<template>
  <b-alert class="custom-alert" :show="activeSessionsCount" variant="danger">
    <div class="alert-content">
      <span class="alert-txt">{{
        $t("emergencyList.emergencySessionsActiveNow")
      }}</span>
      <b-button @click="goToEmergencySessionPage" class="view-btn">{{
        $t("common.view")
      }}</b-button>
    </div>
  </b-alert>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AlertFoundActiveSession",
  data() {
    return {
      activeSessionsCount: false,
      onlyOneSessionId: null,
      onlyOneSessionName: null,
      activeSessionsData: [],
    };
  },
  methods: {
    ...mapActions("emergency", [
      "fetchActiveSessionsData",
      "setActiveSessionsCount",
    ]),
    ...mapActions("authfack", ["setCurrentEntity"]),
    goToEmergencySessionPage() {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";
      if (this.onlyOneSessionId && this.onlyOneSessionName) {
        this.$router.push({
          path: `/emergency-sessions/${this.onlyOneSessionName}/${this.onlyOneSessionId}`,
        });
      } else {
        window.location.href = `${process.env.VUE_APP_DOMAIN}/emergency-sessions`;
      }
    },
    checkActiveSessions() {
      this.activeSessionsCount = false;
      if (this.activeSessionsData && this.activeSessionsData.length > 0) {
        this.activeSessionsCount = true;
        if (this.activeSessionsData.length == 1) {
          this.onlyOneSessionId = this.activeSessionsData[0].id;
          this.onlyOneSessionName = this.activeSessionsData[0].name;
        }
      }
      this.setActiveSessionsCount(this.activeSessionsCount);
      return this.activeSessionsCount;
    },
  },
  computed: {
    ...mapGetters("emergency", ["getActiveSessionsData"]),
  },
  beforeMount() {
    this.fetchActiveSessionsData().then(async (data) => {
      // console.log('activeSessionsData', data.data);
      this.activeSessionsData = await data.data.activeSessions;
      await this.setCurrentEntity(data.data.entity);
      this.checkActiveSessions();
    });
  },
  watch: {
    getActiveSessionsData() {
      this.checkActiveSessions();
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-alert {
  background: #f46a6a !important;
  border-radius: 38px;
  height: 38px;
  margin-bottom: 8px !important;

  padding: 0px !important;
  display: flex;
  align-items: center;
  .alert-content {
    display: flex;
    gap: 32px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .alert-txt {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-btn {
    background: #ffffff;
    border-radius: 13.5px;
    height: 21px;
    width: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;

    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #f46a6a !important;
  }
}
</style>
